var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[_vm.isBoldFont ? 'averta-bold' : 'averta-reguler', {'btn-secondary': _vm.isSecondary}],style:(_vm.buttonStyle),on:{"click":_vm.handleClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }